import React, { useState, useEffect, useMemo } from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import API from "../api";
import { store } from "store/index";
import { useNavigate } from "react-router-dom";
import { setAlert } from "action/index";
import { getCountryForTimezone } from "countries-and-timezones";
// import PackagesTabs from "components/Packages/Tabs";
// import Plans from "page/plans";
// import CrackedCodeSlider from "../components/Frontend/Sliders/CrackedCodeSlider";
import HeroSectionUpdated from "components/PublicPagesReusable/HeroSectionUpdated";
import ReusableHomePageSlider from "./ReusableHomePageSlider";
import Frame1 from "../assets/images/public-pages/Frame1.svg";
import Frame2 from "../assets/images/public-pages/Frame2.svg";
import Frame3 from "../assets/images/public-pages/Frame3.svg";
import Frame4 from "../assets/images/public-pages/Frame4.svg";
import Frame5 from "../assets/images/public-pages/Frame5.svg";
import Frame6 from "../assets/images/public-pages/Frame6.svg";
import Frame7 from "../assets/images/public-pages/Frame7.svg";
import Frame8 from "../assets/images/public-pages/Frame8.svg";
import Frame9 from "../assets/images/public-pages/Frame9.svg";
import Frame10 from "../assets/images/public-pages/Frame10.svg";
import Frame11 from "../assets/images/public-pages/Frame11.svg";
import Frame12 from "../assets/images/public-pages/Frame12.svg";
import Frame13 from "../assets/images/public-pages/Frame13.svg";
import Frame14 from "../assets/images/public-pages/Frame14.svg";
import Frame15 from "../assets/images/public-pages/Frame15.svg";
import Frame16 from "../assets/images/public-pages/Frame16.svg";
import Frame17 from "../assets/images/public-pages/Frame17.svg";
import Frame18 from "../assets/images/public-pages/Frame18.svg";
import Frame19 from "../assets/images/public-pages/Frame19.svg";
import PteMockTest from "../assets/images/public-pages/pte-mock-test.png";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import SplitSection from "components/PublicPagesReusable/SplitSection";
import AIPowered from "../assets/images/public-pages/AI-Powered.svg";
import Training from "../assets/images/public-pages/Training-Support.svg";
import CoursePlans from "../assets/images/public-pages/CoursePlans.svg";
import Feedback from "../assets/images/public-pages/Feedback.svg";
import Strategies from "../assets/images/public-pages/Strategies.svg";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import MasterAspectSection from "components/PublicPagesReusable/MasterAspectSection";
import TestSection from "components/PublicPagesReusable/TestSection";
import AdvantageSection from "components/PublicPagesReusable/AdvantageSection";
import AiPower from "components/PublicPagesReusable/AiPowerSection";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";
import FaqSection from "components/PublicPagesReusable/FaqSection";

const CardsSlider = {
  dots: true,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  adaptiveHeight: true,
  autoplaySpeed: 5000,
};

const CardSlider = {
  adaptiveHeight: true,
  dots: true,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
};

const FreeMockTest = React.memo(() => {
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);

    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();

    const fetchPackages = () => {
      const country = getCountryForTimezone(
        Intl.DateTimeFormat().resolvedOptions().timeZone,
      );
      let countryId = "AU";
      if (country && country.id) {
        countryId = country.id;
      }
      const url =
        import.meta.env.VITE_URL_ALT +
        "/api/v2/getPackages?countryId=" +
        countryId;
      API({
        url: url,
        method: "GET",
      }).then((res) => {
        if (res.status === 200) {
          const { data } = res.data;
          setPlans(data);
        } else {
          store.dispatch(
            setAlert({ flag: true, type: 2, message: "Something went wrong." }),
          );
        }
      });
    };

    fetchPackages();

    document.body.classList.add("mock-test-page");

    return () => {
      document.body.classList.remove("mock-test-page");
    };
  }, []);

  const groupedPlans = useMemo(() => {
    return {
      silver: plans.filter((p) => p.is_gold === 0),
      gold: plans.filter((p) => p.is_gold === 1),
    };
  }, [plans]);

  const bannerTitle = () => (
    <h1 className="top-section-text FS56FW500 mb-4">
      Stop Failing PTE:{" "}
      <span className="text-success fw-600">
        World’s <br /> No.1 PTE Practice
      </span>{" "}
      Platform
      <br />
      That Guarantees Your
      <br />
      Success With AI-Scoring.
    </h1>
  );

  const heroData = {
    badge: "World's #1 PTE Practice Test Platform",
    title: bannerTitle,
    subtitle:
      "Experience real exam conditions with AI-powered scoring that mirrors the actual PTE algorithm, giving you the confidence to achieve your target score.",
    btn_prepration: {
      text: "Take Free Mock Test Today",
      onClick: `/auth/register`,
    },
    btn_outline: {
      text: "How It Works",
      variant: "outline",
      link: "/auth/register",
    },
    profile: {
      image: "/images/web-new-images/emojis/Updated/Free-mock-hero.png",
    },
    bottomStats: [
      { value: "8", highlight: "+", label: "Years of PTE Expertise" },
      { value: "30", highlight: "+", label: "Countries Served" },
      { value: "/5", highlight: "4.8", label: "Rated PTE Practice App" },
      { value: "-Powered", highlight: "AI", label: "Scoring Engine" },
    ],
  };

  const images = [
    {
      src: Frame1,
      alt: "score-1",
    },
    {
      src: Frame2,
      alt: "score-2",
    },
    {
      src: Frame3,
      alt: "score-3",
    },
    {
      src: Frame4,
      alt: "score-4",
    },
    {
      src: Frame5,
      alt: "score-5",
    },
    {
      src: Frame6,
      alt: "score-6",
    },
    {
      src: Frame7,
      alt: "score-7",
    },
    {
      src: Frame8,
      alt: "score-8",
    },
    {
      src: Frame9,
      alt: "score-9",
    },
    {
      src: Frame10,
      alt: "score-10",
    },
    {
      src: Frame11,
      alt: "score-11",
    },
    {
      src: Frame12,
      alt: "score-12",
    },
    {
      src: Frame13,
      alt: "score-13",
    },
    {
      src: Frame14,
      alt: "score-14",
    },
    {
      src: Frame15,
      alt: "score-15",
    },
    {
      src: Frame16,
      alt: "score-16",
    },
    {
      src: Frame17,
      alt: "score-17",
    },
    {
      src: Frame18,
      alt: "score-18",
    },
    {
      src: Frame19,
      alt: "score-19",
    },
  ];

  const heroDescriptionSection = () => {
    return (
      <div className="text-center d-flex align-items-center justify-content-center flex-column">
        <p className="sub-title text-center FS16FW500 w-75">
          Prepare for PTE success with our comprehensive mock test platform,
          designed specifically for students', professionals, and
          immigrants seeking accurate practice and detailed performance
          analysis.
        </p><br/>
        <p className="sub-title text-center FS16FW500 w-75">
          As Australia's leading PTE preparation provider, we offer the most
          realistic mock test experience available, helping you identify
          weaknesses, track progress, and achieve your desired scores
          with confidence.
        </p>
      </div>
    );
  };

  const skillAreaTitle2 = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        What Are <span className="text-success FS40FW600">PTE Mock Test </span>{" "}
        And <br />
        Why Do You Need Them?
      </h3>
    );
  };

  const spliteSectionData = {
    title: "The Complete",
    highlight: " Mock Test Experience",
    quote:
      "Transform your preparation from guesswork to precision with mock tests that truly matter.",
    features: [
      {
        title: "Real-Time Environment",
        desc: "Authentic test conditions with exact timing and interface",
      },
      {
        title: "AI-Powered Scoring",
        desc: "Instant, accurate scores using actual PTE algorithms",
      },
      {
        title: "Detailed Analytics",
        desc: "Comprehensive breakdown of strengths and weaknesses",
      },
      {
        title: "Unlimited Access",
        desc: "Practice as often as needed throughout your preparation",
      },
      {
        title: "Expert Feedback",
        desc: "Personalized improvement strategies from certified trainers",
      },
    ],
    buttonText: "Start Your Mock Test Preparation",
    onButtonClick: () => {
      const modal = new window.bootstrap.Modal(
        document.getElementById("staticBackdrop"),
      );
      modal.show();
    },
    image: "/images/web-new-images/emojis/Updated/full-mock-experience.webp",
    imagePosition: "left",
    bgColor:
      "linear-gradient(180deg, #0D1830 51.5%, #31207D 116.09%, #7F56D9 181.55%)",
    textColor: "#ffff",
  };

  const skillAreaTitle3 = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        5 Reasons Mock Test Are Your <br />
        <span className="text-success FS40FW600">Secret Weapon </span>For PTE
        Success
      </h3>
    );
  };

  const masterTitle = () => {
    return (
      <h3 className="top-section-text FS40FW600 mb-4">
        Language Academy’s{" "}
        <span className="text-success">
          AI-Powered <br /> Mock Test{" "}
        </span>
        Platform
      </h3>
    );
  };

  const advantageCards = [
    {
      title: "Gain Real Exam Experience",
      text: "Experience the exact pressure, timing, and interface of the actual PTE test before your official exam day.",
      color: "#141414",
      img: AIPowered,
      boxShadow: "0 10px 25px rgba(0,0,0,0.03)",
      borderColor: "rgba(0, 0, 0, 0.05)",
    },
    {
      title: "Identify Your Weak Areas",
      text: "Detailed analytics reveal precisely which question types and skills need improvement, saving you valuable study time.",
      color: "#141414",
      img: Training,
      boxShadow: "0 10px 25px rgba(0,0,0,0.03)",
      borderColor: "rgba(0, 0, 0, 0.05)",
    },
    {
      title: "Master Time Management",
      text: "Learn to pace yourself effectively across all sections, ensuring you complete every question within the allocated time",
      color: "#141414",
      img: CoursePlans,
      boxShadow: "0 10px 25px rgba(0,0,0,0.03)",
      borderColor: "rgba(0, 0, 0, 0.05)",
    },
    {
      title: "Build Unshakeable Confidence",
      text: "Familiarity with the test format eliminates surprises and reduces test-day anxiety.",
      color: "#141414",
      img: Feedback,
      boxShadow: "0 10px 25px rgba(0,0,0,0.03)",
      borderColor: "rgba(0, 0, 0, 0.05)",
    },
    {
      title: "Track Your Progress",
      text: "Monitor your improvement over time with detailed score reports and performance trends.",
      color: "#141414",
      img: Strategies,
      boxShadow: "0 10px 25px rgba(0,0,0,0.03)",
      borderColor: "rgba(0, 0, 0, 0.05)",
    },
  ];

  const testSectionData = {
    title: "Complete",
    highlight: "Mock Tests",
    subtitle: "For all 4 PTE Sections",
    tabs: [
      {
        label: "Speaking",
        icon: (
          <img
            src="/images/web-new-images/icons/w-speak-icon.svg"
            alt="Speaking"
          />
        ),
        content: {
          leftTitle: "What It Tests",
          leftPoints: [
            "Pronunciation, fluency, and oral communication clarity.",
          ],
          centerIcon: "/images/web-new-images/yourApprochIcon.svg",
          centerTitle: "Our Approach",
          centerPoints: [
            "High-quality microphone calibration for accurate assessment",
            "Real-time pronunciation feedback using advanced speech recognition AI",
            "Fluency analysis by AI",
          ],
          rightIcon: "/images/web-new-images/Question-types.svg",
          rightTitle: "Question Types Covered",
          rightPoints: [
            "Read Aloud, Repeat Sentence, Describe Image, Retell Lecture, Answer Short Question, Summarize Group Discussion & Respond to a Situation",
          ],
        },
      },
      {
        label: "Writing",
        icon: (
          <img
            src="/images/web-new-images/icons/w-write-icon.svg"
            alt="Writing"
          />
        ),
        content: {
          leftTitle: "What It Tests",
          leftPoints: [
            "Essay composition, text summarization, and grammatical accuracy",
          ],
          centerIcon: "/images/web-new-images/yourApprochIcon.svg",
          centerTitle: "Our Approach",
          centerPoints: [
            "Template-based essay strategies for consistent high scores",
            "Automated grammar and spelling analysis",
            "Time management tools for efficient writing",
          ],
          rightIcon: "/images/web-new-images/Question-types.svg",
          rightTitle: "Question Types Covered",
          rightPoints: ["Summarize Written Text & Write Essay"],
        },
      },
      {
        label: "Reading",
        icon: (
          <img
            src="/images/web-new-images/icons/w-reading-icon.svg"
            alt="Reading"
          />
        ),
        content: {
          leftTitle: "What It Tests",
          leftPoints: ["Comprehension, vocabulary knowledge, and analytical thinking"],
          centerIcon: "/images/web-new-images/yourApprochIcon.svg",
          centerTitle: "Our Approach",
          centerPoints: [
            "Speed reading techniques integrated into practice",
            "Vocabulary building exercises within context",
            "Strategic approaches for different question formats",
          ],
          rightIcon: "/images/web-new-images/Question-types.svg",
          rightTitle: "Question Types Covered",
          rightPoints: [
            "Fill in the Blanks (Dropdown), Multiple Choice - Multiple Answers, Reorder Paragraph, Fill in the Blanks (Drag and Drop) & Multiple Choice - Single Answer",
          ],
        },
      },
      {
        label: "Listening",
        icon: (
          <img
            src="/images/web-new-images/icons/w-listen-icon.svg"
            alt="Listening"
          />
        ),
        content: {
          leftTitle: "What It Tests",
          leftPoints: [
            "Audio comprehension, note-taking, and information processing.",
          ],
          centerIcon: "/images/web-new-images/yourApprochIcon.svg",
          centerTitle: "Our Approach",
          centerPoints: [
            "Authentic accent variations for realistic preparation",
            "Note-taking strategies for complex audio passages",
            "Focus training for key information identification",
          ],
          rightIcon: "/images/web-new-images/Question-types.svg",
          rightTitle: "Question Types Covered",
          rightPoints: [
            "Summarize Spoken Text, Multiple Choice - Multiple Answers, Fill in the Blanks (Type In), Highlight Correct Summary, Multiple Choice - Single Answer, Select Missing Word, Highlight Incorrect Words & Write from Dictation",
          ],
        },
      },
    ],
    cta: "Practice All Sections Today",
  };

  const titleSectionHeader = () => { return (
    <h3 className="top-section-text FS40FW600">
      The Language Academy <br />
      <span className="text-success FS40FW600">Scoring Advantage</span>
    </h3>
  )};

  const advantageSectionData = {
    titleSection: titleSectionHeader,
    highlightBox: "5-Step Precision Scoring Process",
    buttonText: "Get Your Detailed Score Analysis",

    timeline: [
      {
        number: 1,
        title: "Automated Scoring",
        desc: "Your responses are instantly evaluated using our proprietary AI system.",
      },
      {
        number: 2,
        title: "Expert Score Review",
        desc: "Analyze your results to identify specific improvement opportunities.",
      },
      {
        number: 3,
        title: "Detailed Scorecard Generation",
        desc: "In-depth reports show your performance across all skills and question types.",
      },
      {
        number: 4,
        title: "Personalized Feedback Delivery",
        desc: "Targeted recommendations help you focus your study efforts where they'll have maximum impact.",
      },
      {
        number: 5,
        title: "Ongoing Tutor Support",
        desc: "Expert guidance available to help you implement improvement strategies effectively.",
      },
    ],
  };

  const uniqueTitle3 = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        What Makes <span className="text-success FS40FW600"> Our Scoring</span> {" "}
        Unique
      </h3>
    );
  };

  const uniqueCards = [
    {
      title: "Question-Wise Feedback",
      text: "Understand exactly what went wrong with each response",
      color: "#141414",
      img: AIPowered,
      boxShadow: "0 10px 25px rgba(0,0,0,0.03)",
      borderColor: "rgba(0, 0, 0, 0.05)",
    },
    {
      title: "Trend Analysis",
      text: "Track your improvement patterns over multiple attempts",
      color: "#141414",
      img: Training,
      boxShadow: "0 10px 25px rgba(0,0,0,0.03)",
      borderColor: "rgba(0, 0, 0, 0.05)",
    },
    {
      title: "Skill Mapping",
      text: "See how each question type affects your overall score",
      color: "#141414",
      img: CoursePlans,
      boxShadow: "0 10px 25px rgba(0,0,0,0.03)",
      borderColor: "rgba(0, 0, 0, 0.05)",
    },
    {
      title: "Instant Delivery",
      text: "No waiting – get your results immediately after completion",
      color: "#141414",
      img: Feedback,
      boxShadow: "0 10px 25px rgba(0,0,0,0.03)",
      borderColor: "rgba(0, 0, 0, 0.05)",
    },
  ];

  const sliderList = {
    title: "Hear From Our <span>Successful Students'</span>",
    subtitle: "casc",

    settings: {
      slidesPerView: 3,
      spaceBetween: 20,
      breakpoints: {
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
    },

    items: [
      {
        id: 1,
        name: "Gagan Brar",
        location: "-",
        description:
          "I had a great experience at language academy and scored 8 bands in each. Roopali was an amazing tutor. She kept in touch with me right up until I got my results and supported me the whole way. Her lessons really helped me improve, especially in Writing and Speaking. I highly recommend it!",
        image: "/images/web-new-images/new-content-slider/gagan-brar.svg",
      },
       {
        id: 2,
        name: "Ushna Noor",
        location: "Lahore, Pakistan",
        description:
          "LA academy made PTE preparation much clearer and less stressful for me. The study material was up to date, and the strategies shared by Roopali for speaking and writing were particularly helpful. I liked how Roopali explained everything step by step, which made it easier to practise independently. It’s a great option for anyone looking for focused and flexible PTE preparation.",
        image: "/images/web-new-images/new-content-slider/ushna-noor.svg",
      },
      {
        id: 3,
        name: "CeMas Poojas",
        location: "Cabadbaran, Agusan del Norte",
        description:
          "I would like to express my sincere gratitude to LA Academy for their outstanding support and guidance during my PTE preparation. I just received my results today, and I am excited to share that I achieved an overall score of 80! A special thank you to Ma'am Sana and the entire team for your dedication and encouragement. Your efforts truly made a difference in my success. I highly recommend LA Academy to anyone looking to excel in their language proficiency tests!",
        image: "/images/web-new-images/new-content-slider/ceemas-poojas.svg",
      },
      {
        id: 4,
        name: "Riddhi Patel",
        location: "Rajkot, Gujarat",
        description:
          "I just got 4 online one on one classes with vishika. She is really good in understanding the dilemma of the students, and suggests the tips, tricks and ideas according to that. I got 81 overall score with 7 each in two modules and 8 each in other modules. I am really happy to study with a language academy, and especially with vishika. Thank you so much for making my journey easier…….",
        image: "/images/web-new-images/new-content-slider/riddhi-patel.svg",
      },
      {
        id: 5,
        name: "Nellam Kumari",
        location: "-",
        description:
          "The LA website is one of the best websites to practice and get real time feedback as well. The mock tests are realistic and practice questions are segregated by level of difficulty. I prepared mostly by watching Varun's videos on youtube and practicing on the website and got a 90 score. I also had a one on one session with Navneet Kaur from LA to get my mock tests and approach reviewed. She had been very helpful and responsive in addressing my queries. Thanks a lot team!",
        image: "/images/web-new-images/new-content-slider/neelam-kumari.svg",
      },
      {
        id: 6,
        name: "Liza Liza",
        location: "Brisbane, Queensland, Australia",
        description:
          "I’m incredibly grateful to LA Academy for helping me achieve my desired PTE score! The guidance, strategies, and constant support from the trainers made a huge difference in my preparation. The practice materials were up-to-date and very similar to the actual exam. What I appreciated most was the personal attention and honest feedback, which helped me improve my weak areas quickly. Thank you LA Academy for your dedication and for helping me reach my goal. Highly recommend to anyone serious about getting their target PTE score!",
        image: "/images/web-new-images/new-content-slider/liza.svg",
      },
      {
        id: 7,
        name: "Arvinder Kaur Rai",
        location: "-",
        description:
          "Hi its arvinder, I am currently living in saskatoon, canada. I gave my pte exam and got my desired scores. I highly recommend everyone please join language academy for getting desired scores. They are offering online classes as well as per your schedule. The most positive point is that the staff is really helpful. Specially mam ridhima, shivani and sana",
        image: "/images/web-new-images/new-content-slider/aravinder-kaur-rai.svg",
      },
      {
        id: 8,
        name: "Shreya Pokhrel",
        location: "Jhapa, Nepal",
        description:
          "I would highly recommend LA academy. I was able to secure 8 within 2 weeks of time. They are always willing to help you at any time. Vishika mam, she was super flexible and always replied to me whenever I messaged her. I just wanted to let you know, if you actually want to score your desired band, then LA Academy is your ultimate destination.",
        image: "/images/web-new-images/new-content-slider/shreya-pokhrel.svg",
      },
      {
        id: 9,
        name: "Satyam Kannaujia",
        location: "Lucknow, Uttar Pradesh, India",
        description:
          "I highly recommend LA to people who are looking for guidance to excel in their PTE exam. The tutors are very helpful and their guidance really works. I would like to thank all of the LA team for helping me to achieve my desired score",
        image: "/images/web-new-images/new-content-slider/satyam-kannaujia.svg",
      },
    ]
  };

  const preprationWorkTitle = () => {
    return (
      <h3 className="top-section-text mb-4 white FS40FW600">
        How To Your <span className="text-success FS40FW600">Mock Test</span>
      </h3>
    );
  };

  const preprationWorkCards = [
    {
      title: "Register & Choose Your Package",
      text: "Select the package that best fits your preparation timeline and goals.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/REGISTER-CHOOSE.svg",
      badge: "Step 1",
      borderColor:'#FFFFFF3D' 
    },
    {
      title: "Access The LA PTE Portal",
      text: "Log into our user-friendly platform designed for optimal test-taking experience",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/ANALYZE-IMPROVE.svg",
      badge: "Step 2",
      borderColor:'#FFFFFF3D'
    },
    {
      title: "Take Your Mock Tests",
      text: "Choose from full-length mocks, sectional mocks, or extensive mocks",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/Take-Tests.svg",
      badge: "Step 3",
      borderColor:'#FFFFFF3D'
    },
    {
      title: "Analyze & Improve",
      text: "Review your detailed results, implement feedback, and track your progress over time.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/Access-LA.svg",
      badge: "Step 4",
      borderColor:'#FFFFFF3D'
    }
  ];

  const NewListSkills = [
    {title:'24/7 Platform Access',desc:'Practice whenever it suits your schedule.'},
    {title:'Mobile-Friendly Interface',desc:'Take tests on any device'},
    {title:'Automatic Progress Sync',desc:'Your data follows you across all devices'},
    {title:'Result History Storage',desc:'Access all previous attempts and track improvement'},
  ]

    const faqQuestions = [
    {
      question: "How many mock tests should I take for optimal preparation?",
      answer: "Most students achieve their best results after taking 15-25 full mock tests over 4-6 weeks. Our platform ensures you can practice as much as needed without restrictions."
    },
    {
      question: "How accurate are your mock test scores compared to the real PTE exam?",
      answer: "Our AI-powered scoring system has a 96.3% correlation with actual PTE results. Students typically see score variations of only 3-5 points between our mock tests and their real exam."
    },
    {
      question: "Do you provide sectional mock tests or only full-length tests?",
      answer: "We offer both! Choose from full 2-hour mock tests or individual section practice (Reading, Writing, Listening, Speaking)"
    },
    {
      question: "How quickly do I receive my mock test results?",
      answer: "Results are delivered instantly upon completion. Your detailed scorecard, including question-wise analysis and improvement recommendations is available immediately."
    },
    {
      question: "What's the difference between Silver and Gold packages?",
      answer: "Silver provides complete mock test access with AI scoring and basic analytics. Gold adds premium video courses, detailed explanation videos, and advanced strategy videos for comprehensive preparation."
    },
    {
      question: "Do you offer customer support if I have technical issues?",
      answer: "Absolutely! Our support team is available via email (info@languageacademy.com.au) and phone (+61 426230061) to assist with any technical or preparation questions."
    }
  ];
  return (
    <React.Fragment>
      <Helmet>
        <title>AI-Powered Practice PTE Mock Test | LA Language Academy</title>
        <meta
          name="description"
          content="Prepare for PTE success with LA Language Academy's AI-powered mock tests. Simulate real exam conditions, get instant scoring & detailed performance analysis."
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href={`https://www.languageacademy.com.au/mock-test`}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta
          name="twitter:title"
          content="AI-Powered Practice PTE Mock Test | LA Language Academy"
        />
        <meta
          name="twitter:description"
          content="Prepare for PTE success with LA Language Academy's AI-powered mock tests. Simulate real exam conditions, get instant scoring & detailed performance analysis."
        />
        <meta
          name="twitter:image"
          content={`https://www.languageacademy.com.au/images/logol.png`}
        />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta
          property="og:url"
          content={`https://www.languageacademy.com.au/mock-test`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="AI-Powered Practice PTE Mock Test | LA Language Academy"
        />
        <meta
          property="og:description"
          content="Prepare for PTE success with LA Language Academy's AI-powered mock tests. Simulate real exam conditions, get instant scoring & detailed performance analysis."
        />
        <meta
          property="og:image"
          content={`https://www.languageacademy.com.au/images/logol.png`}
        />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "How many mock tests should I take for optimal preparation?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Most students achieve their best results after taking 15-25 full mock tests over 4-6 weeks. Our platform ensures you can practice as much as needed without restrictions.",
                },
              },
              {
                "@type": "Question",
                name: "How accurate are your mock test scores compared to the real PTE exam?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Our AI-powered scoring system has a 96.3% correlation with actual PTE results. Students typically see score variations of only 3-5 points between our mock tests and their real exam.",
                },
              },
              {
                "@type": "Question",
                name: "Do you provide sectional mock tests or only full-length tests?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "We offer both! Choose from full 2-hour mock tests or individual section practice (Reading, Writing, Listening, Speaking)",
                },
              },
              {
                "@type": "Question",
                name: "How quickly do I receive my mock test results?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Results are delivered instantly upon completion. Your detailed scorecard, including question-wise analysis and improvement recommendations is available immediately.",
                },
              },
              {
                "@type": "Question",
                name: "What's the difference between Silver and Gold packages?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Silver provides complete mock test access with AI scoring and basic analytics. Gold adds premium video courses, detailed explanation videos, and advanced strategy videos for comprehensive preparation.",
                },
              },
              {
                "@type": "Question",
                name: "Do you offer customer support if I have technical issues?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely! Our support team is available via email (info@languageacademy.com.au) and phone (+61 426230061) to assist with any technical or preparation questions.",
                },
              },
            ],
          })}
        </script>
      </Helmet>
      <Header />
      <main className="new-design">
        <HeroSectionUpdated data={heroData} />
        <div className="fame-wall off-white">
          <ReusableHomePageSlider images={images} />
        </div>
        <div className="d-flex align-items-center gap-4 flex-column pb-4 off-white">
          {heroDescriptionSection()}
          <ButtonComp
            link={() => {
              const modal = new window.bootstrap.Modal(
                document.getElementById("staticBackdrop"),
              );
              modal.show();
            }}
            btnText={"Take Your Free Mock Test Today"}
          />
        </div>
        <div className="custom-container py-5">
          <ContentImageSection
            contentSection={skillAreaTitle2}
            quoteText={
              "PTE mock tests are full-length practice exams created to resemble the structure, timing, and question formats of the real PTE Academic test."
            }
            btnClassName="mt-2"
            image={PteMockTest}
            imageClassName="immigration-test-img"
            paragraphs={[
              '<span class="plus-sans FS17FW500 fw-700 mt-5">They help you:</span> ',
            ]}
            listColumns={[
              [
                "Experience exam pressure before test day",
                "Improve time management skills",
                "Understand scoring expectations",
                "Build familiarity with all question types",
              ],
            ]}
            listBottomText="Our system evaluates your responses using AI-based assessment models aligned with widely known PTE scoring principles."
            btnLink={"/auth/register"}
            btnText={"Start Your Mock Test Preparation"}
          />
        </div>
        <SplitSection {...spliteSectionData} />
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle3}
          lifestyleCards={advantageCards}
          btnText={"Experience The Difference Today"}
          skillSubtitle={
            "Don't walk into your PTE exam unprepared. Mock tests are the difference between hoping for success and guaranteeing it."
          }
        />
        <MasterAspectSection
          titleSection={masterTitle}
          description={
            "<span class='fst-italic'>Our revolutionary mock test platform uses advanced artificial intelligence to provide the<br /> most accurate PTE preparation experience available.</span>"
          }
          cards={[
            {
              title: "Automated Scoring Technology",
              items: [
                {
                  title:
                    "<span class='fw-700'>AI-based scoring inspired by PTE criteria</span>",
                  description: "Our AI mirrors the actual PTE scoring system",
                },
                {
                  title: "<span class='fw-700'>Instant Results</span>",
                  description:
                    "Receive your scores within seconds of completion",
                },
                {
                  title: "<span class='fw-700'>Precision Accuracy</span>",
                  description: "96.3% correlation with actual PTE scores",
                },
              ],
            },
            {
              title: "Comprehensive Test Varieties",
              className: "card2",
              items: [
                {
                  title: "<span class='fw-700'>Full-Length Mock Tests</span>",
                  description: "Complete 2-hour examinations with all sections",
                },
                {
                  title: "<span class='fw-700'>Sectional Practice Tests</span>",
                  description:
                    "Focus on specific sections (Reading, Writing, Listening & Speaking)",
                },
              ],
            },
          ]}
          btnText="Unlock Your Potential With Our Platform"
          btnLink="/auth/register"
          btnImg="/images/web-new-images/new-dark-arrow.svg"
        />

        <TestSection data={testSectionData} />

        <AdvantageSection data={advantageSectionData} />

        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={uniqueTitle3}
          lifestyleCards={uniqueCards}
          btnText2={"Get Your Detailed Score Analysis"}
          btnLink2={() => {
            const modal = new window.bootstrap.Modal(
              document.getElementById("staticBackdrop"),
            );
            modal.show();
          }}
          center={"d-flex justify-content-center text-center"}
          leftSection={false}
        />

        <div
          className="custom-container py-5 text-center position-relative"
          style={{
            background: "radial-gradient(circle at center,#7f56d929,#fff)",
          }}
        >
          <h3
            className="FS40FW600 mb-3"
            style={{
              fontFamily: "'Tropiline', sans-serif",
              fontStyle: "italic",
              color: "#94C23C",
            }}
          >
            <span
              style={{
                fontFamily: "'Bricolage Grotesque', serif",
                fontStyle: "normal",
                color: "#141414",
              }}
            >
              Our Students'
            </span>
            <br />
            Success Stories
          </h3>
          <p className="plus-sans FS20FW500 fw-400 mb-4">
            <span className="fw-700">Outstanding Achievement Rate</span> 12 out
            of 15 students' score 75+ after using our mock test platform
          </p>
          <span className="plus-sans fw-700 FS20FW500 text-center">
            Impressive Performance Metrics
          </span>
          <div className="d-flex flex-wrap gap-5 justify-content-center mt-5 flex-column flex-md-row justify-content-md-between align-items-center align-items-md-start">
            {[
              {
                number: "1M+",
                label:
                  "<p class='FS16FW500 plus-sans' style={{ color: '#686868' }}><span class='fw-700 text-black'>Members</span> have trusted our platform for their PTE preparation</p>",
              },
              {
                number: "29,000+",
                label:
                  "<p class='FS16FW500 plus-sans' style={{ color: '#686868' }}><span class='fw-700 text-black'>Practice Questions</span> provide comprehensive coverage of all exam areas</p>",
              },
              {
                number: "3,000+",
                label:
                  "<p class='FS16FW500 plus-sans' style={{ color: '#686868' }}><span class='fw-700 text-black'>Mock Tests</span> completed daily by students' worldwide</p>",
              },
              {
                number: "35,000+",
                label:
                  "<p class='FS16FW500 plus-sans' style={{ color: '#686868' }}><span class='fw-700 text-black'>Daily Sign-ins</span> demonstrate the platform's effectiveness and popularity</p>",
              },
            ].map((stat, idx) => (
              <div
                key={idx}
                className="d-flex flex-column align-items-center col-2"
              >
                <h3
                  style={{
                    fontFamily: "'Bricolage Grotesque', serif",
                    fontWeight: 800,
                    fontSize: "48px",
                    lineHeight: "120%",
                    color: "#141414",
                    margin: 0,
                  }}
                >
                  {stat.number.replace("+", "")}
                  <span style={{ color: "#48A75C" }}>+</span>
                </h3>
                <p
                  className="plus-sans"
                  style={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "#686868",
                    margin: "12px 0 0",
                    textAlign: "center",
                  }}
                  dangerouslySetInnerHTML={{ __html: stat.label }}
                />
              </div>
            ))}
          </div>
        </div>

        <AiPower btnText="Start Free PTE Practice" />

        <TestimonialSection
          extraWidth={"700px"}
          title={`<span class="hero-title FS40FW600 text-start mb-0">Hear From Our <br/> <span class="green-text">Successful Students'</span></span>`}
          titleClass="text-start"
          // subtitle={"<span style={{maxWidth: '700px'}}>Your success is our mission. Let us guide you toward the future you've been dreaming of.</span>"}
          showBtn={true}
          btnText={"Join Our Success Community"}
          btnLink="/auth/register"
          sliderList={sliderList}
          extraClass={"flex-column flex-lg-row flex-lg-row text-start"}
        />

      <section className="py-5">
          <div className="custom-container">

            {/* Heading */}
            <div className="text-center mb-5">
              <h3 className="top-section-text FS40FW600">
                Choose Your{" "}
                <span className="text-success">Mock Test</span> Package
              </h3>

            <p className="mt-3 FS20FW500 plus-sans fw-400" style={{color:'#383838'}}>
                {`Unlimited access to Australia's most accurate PTE mock tests. Starting from ${
                  groupedPlans?.silver?.[0]?.price
                    ? `${groupedPlans?.silver?.[0]?.currency?.includes("20b9") ? "₹" : "$"}${groupedPlans?.silver?.[0]?.price}`
                    : "$89"
                }.`}
            </p>
            </div>

            <div className="row g-4 justify-content-center">

              <div className="col-12 col-lg-5 d-flex">
                <PlanCard
                  packageNo="PACKAGE 1"
                  title="Silver Package"
                  plans={groupedPlans?.silver}
                  dark={false}
                  description="Everything you need to master the mock test"
                  desc_color="#686868"
                  onClick={() => navigate("/auth/register")}
                />
              </div>

              <div className="col-12 col-lg-5 d-flex">
                <PlanCard
                  packageNo="PACKAGE 2"
                  title="Gold Package"
                  plans={groupedPlans?.gold}
                  dark
                  badge="BEST SELLER"
                  description="Everything in Silver, plus premium content"
                  desc_color="#F8F8F8"
                  onClick={() => navigate("/auth/register")}
                />
              </div>

            </div>

            <p className="text-center mt-5 plus-sans FS16FW500 fw-400" style={{color:'#383838'}}>
              All packages auto-renew. Cancel anytime.
            </p>

          </div>
      </section>

        <SkillAreas
          skillAreaTitle={preprationWorkTitle}
          // skillSubtitle="<span>Unlike traditional English coaching, our approach targets the exact mechanics behind<br/> PTE, NAATI CCL, and IELTS scoring systems.<br/><br/>
          // We've reverse -engineered these exams through 8+ years of intensive research and over<br/> 50,000 student successes to create a methodology that delivers predictable results:</span>"
          lifestyleCards={preprationWorkCards}
          btnText2="Start Your Mock Test Journey"
          img="/images/web-new-images/new-dark-arrow.svg"
          sliders={4.2}
          skillBottomBoldtitle={'Available Anytime, Anywhere'}
          bottomListNew={NewListSkills}
          center={"d-flex justify-content-center text-center"}
          leftSection={false}
        />

        <AppBannerCustom
          appName="PTE"
          description="PTE PRACTICE"
          mobileImage="/images/web-new-images/HomePageImage/PTE-app-1.png"
          playStoreLink={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`}
          appStoreLink={`${import.meta.env.VITE_PTE_IOS_APP_URL}`}
        />
        <FaqSection questions={faqQuestions} />
      </main>
      <Footer />
    </React.Fragment>
  );
});

const PlanCard = ({
  packageNo,
  title,
  plans,
  dark = false,
  badge,
  description,
  desc_color,
  onClick,
}) => {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (plans?.length > 0) {
      setSelected(plans[0]);
      console.log(selected);
    }
  }, [plans]);
  
  const getCurrencySymbol = (currency) => {
    if (currency?.includes("20b9")) return "₹";
    return "$";
  };

  if (!selected) return null;

  return (
    <div className={`pricing-card-new w-100 ${dark ? "pricing-card-dark" : ""}`}>
      
      {badge && (
        <span className="popular-badge FS16FW500 fw-400">
          {badge}
        </span>
      )}

      <small className="package-label FS16FW500 fw-400 mb-2">
        {packageNo}
      </small>

      <span className="fw-600 FS24FW500">
        {title}
      </span>

      <p className="FS14FW600 fw-500 mb-0" style={{color: desc_color}}>
        {description}
      </p>

      {/* Duration buttons */}
      <div className="duration-tabs">
        {plans.map((plan) => (
          <button
            key={plan.id}
            onClick={() => setSelected(plan)}
            className={`duration-btn ${
              selected?.id === plan.id ? "active" : ""
            } ${
              dark ? "active-dark" : ""
            }`}
          >
            <p className="mb-0 main-title FS20FW500">
              {plan.duration} Month
              {plan.duration > 1 ? "s" : ""}
            </p>

            <p className="FS12 fw-400 plus-sans mb-0">
            {plan.discount ? (
                `Save ${plan.discount}%`
              ):(
                `Standard`
              )}
              </p>
          </button>
        ))}
      </div>

      {/* Price */}
      <div className="mt-4">
        <span className={`plus-sans FS14FW600`} style={{color: selected?.is_gold ? '#f8f8f8b3':'#686868'}}>Starting From</span>

        <div className="FS40FW600 fw-700 main-title">
          {getCurrencySymbol(selected?.currency)}
          {selected?.price}{" "}

          <span className={`plus-sans FS14FW600`} style={{color: selected?.is_gold ? '#f8f8f8b3':'#686868'}}>
            {getCurrencySymbol(selected?.currency) === "₹"
              ? "INR"
              : "AUD"}
          </span>
        </div>

        <span className={`plus-sans FS14FW600`} style={{color: selected?.is_gold ? '#f8f8f8b3':'#686868'}}>
          Best Seller · Most popular choice
        </span>
      </div>

      {/* Features */}
      <ul className={`feature-list-price-new mt-4`} style={{color: selected?.is_gold ? '#D0D0D0':'#686868'}}>
        {selected?.is_gold ? (
          <>
            <li>Everything in Silver Package</li>
            <li>Reading explanation videos</li>
            <li>Full premium strategy videos</li>
            <li>Complete video course library</li>
            <li>Unlimited sectional mock tests</li>
            <li>Priority expert support</li>
          </>
        ) : (
          <>
            <li>Everything you need to master the mock test</li>
            <li>Full Access to 29,000+ exam questions</li>
            <li>Latest Templates and prediction files</li>
            <li>Sectional Mock Tests with detailed scoring</li>
            <li>Full-Length Mock Tests with comprehensive analysis</li>
            <li>Extensive Mock Tests with expert insights</li>
          </>
        )}
      </ul>

      <button className={`card-btn plus-sans FS17FW500 fw-700 to-unset-transform w-100 ${badge ? "primary-btn" : "cta-btn"}`} 
            onClick={onClick} >
          Start Your Plan{" "}
          <img
            src={`/images/web-new-images/${badge ? "new-dark-arrow.svg" : "right-arrow-black.svg"}`}
            alt="Register Now"
          />
        </button>

    </div>
  );
};

export default FreeMockTest;
